import { useNavigate } from 'react-router-dom';
import postmanImage from '../../../assets/postmanImage.png'
import CustomButton from '../../../components/common/CustomButton/CustomButton'
import { ChevronRight } from 'lucide-react';

const FormSubmissionPage = ({
    title = (
        <>
            Your Application<br />
            Has Been Sent To<br />
            Verification
        </>
    ),
    subTitle = "Stay ahead! Browse our courses while we verify",
    path="/login"
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(path)
    }
    return (
        <div className="flex flex-col justify-start items-center w-full bg-blue-50 min-h-screen p-4">
            <img
                src={postmanImage}
                style={{
                    width: "400px",
                    height: "400px"
                }}
                alt="Postman"
            />
            <h1 className="text-center font-bold text-xl w-full mt-4">
                {title}
            </h1>
            <p className="m-2 text-center text-sm">
                {subTitle}
            </p>

            <div className="mt-6">
                <CustomButton
                    type="button"
                    variant="primary"
                    endIcon={<ChevronRight size={15} />}
                    label="Proceed"
                    onClick={handleClick}
                />
            </div>
        </div>
    );
};

export default FormSubmissionPage;
